<template>
  <div class="hero is-widescreen">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <img src="@/assets/image/img_tball_mobile@2x.png" />
        <span>TREND MICRO</span>
        <h1 v-html="title"></h1>
      </div>
    </nav>
    <section class="hero">
      <div class="hero-body" :style="{'height':  dynamicHeight + 'px'}">
        <div class="container has-text-centered">
          <h1 class="title">{{ $t('error_title') }}</h1>
          <img src="@/assets/image/img_error.png" />
          <h2 class="subtitle">{{$t('error_description')}}</h2>
        </div>
      </div>
      <div class="hero-foot">
        <div class="footer-policy">
          <a target="_self" :href="get_policies_link">{{$t('footer_legalpolicy')}}</a> •
          <a target="_self" :href="get_contact_link">{{$t('footer_contactus')}}</a> •
          <a target="_self" :href="get_trendmicro_link">{{$t('footer_tm')}}</a>
        </div>
      </div>

      <footer class="footer">
        <section class="footer-img-section">
          <img src="@/assets/image/img_footer_Logo_s@2x.png" />
        </section>
        <section class="border"></section>
        <section class="footer-copyright-section">
          <div class="container footer-copyright">
            <a target="_self" :href="get_policies_link">{{$t('footer_legalpolicy')}}</a>
            <span>•</span>
            <a target="_self" :href="get_contact_link">{{$t('footer_contactus')}}</a>
            <span>•</span>
            <a target="_self" :href="get_trendmicro_link">{{$t('footer_tm')}}</a>
          </div>
          <p v-html="copyright"></p>
        </section>
      </footer>
    </section>
  </div>
</template>
<script>
import i18n from "@/i18n";
import translateLang from "@/lang.js";
export default {
  name: "ErrorPage",
  data() {
    return {
      policies_link:
        "https://gr.trendmicro.com/GREntry/NonPayment?Target=MyAccount&FunID=Privacy&Locale=",
      contact_link:
        "https://gr.trendmicro.com/GREntry/NonPayment?Target=MyAccount&FunID=ContactUs&Locale=",
      trendmicro_link:
        "https://gr.trendmicro.com/GREntry/NonPayment?Target=MyAccount&FunID=TrendMicro&Locale=",
      locale: "EN-US",
      dynamicHeight: 0
    };
  },
  beforeCreate() {
    // document
    //   .getElementsByTagName("html")[0]
    //   .setAttribute("lang", navigator.language || navigator.userLanguage);
  },
  created() {
    this.locale = navigator.language || navigator.userLanguage;
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.dynamicHeight =
      window.innerHeight -
      document.getElementsByClassName("footer-policy")[0].offsetHeight -
      document.getElementsByClassName("navbar-brand")[0].offsetHeight -
      96;
  },
  watch: {
    innerHeight: function(height) {}
  },
  computed: {
    title() {
      return this.$t("header_text");
    },
    get_policies_link() {
      return this.policies_link + this.locale;
    },
    get_contact_link() {
      return this.contact_link + this.locale;
    },
    get_trendmicro_link() {
      return this.trendmicro_link + this.locale;
    },
    copyright() {
      var d = new Date();
      var year = d.getFullYear();
      return this.$t("footer_copyright").replace("{YEAR}", year);
    }
  },
  methods: {
    handleResize() {
      console.log(window.innerHeight);
      console.log(
        document.getElementsByClassName("footer-policy")[0].offsetHeight
      );
      console.log(
        document.getElementsByClassName("navbar-brand")[0].offsetHeight
      );
      var border = window.innerWidth <= 550 ? 1 : 0;
      this.dynamicHeight =
        window.innerHeight -
        document.getElementsByClassName("footer-policy")[0].offsetHeight -
        document.getElementsByClassName("navbar-brand")[0].offsetHeight -
        96 -
        border;
    }
  }
};
</script>
<style  src="@/../node_modules/bulma/css/bulma.min.css">
</style>
<style   scoped lang="scss"rel="stylesheet/scss" src="@/assets/style/error.scss">
</style>



// WEBPACK FOOTER //
// src/pages/error/ErrorPage.vue